export default {"src":"/_next/static/media/EMPTY_SPIDER.87ea077c.svg","height":383,"width":468,"blurWidth":0,"blurHeight":0};